export const minxin={
    methods:{
        goto(url){
            this.$router.push(url)
        },
        openNew(url){
            window.open(url)
        }
    }
}